namespace RioERP.Masters {
    export interface EmailTemplateVariablesRow {
        Id?: number;
        VariableCode?: string;
        VariableName?: string;
    }

    export namespace EmailTemplateVariablesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'VariableCode';
        export const localTextPrefix = 'Masters.EmailTemplateVariables';
        export const lookupKey = 'Masters.EmailTemplateVariables';

        export function getLookup(): Q.Lookup<EmailTemplateVariablesRow> {
            return Q.getLookup<EmailTemplateVariablesRow>('Masters.EmailTemplateVariables');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            VariableCode = "VariableCode",
            VariableName = "VariableName"
        }
    }
}
